import {
  Box,
  createStyles,
  Text,
  Select,
  TextInput,
  Modal,
  Button,
  Loader,
  Center,
  Flex,
  Anchor,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";

import { useSelector } from "react-redux";
import { getelibilitystatus } from "../../services";
import { showError } from "../../utils";
import swal from "sweetalert";

import EligibilityProvider from "./EligibilityProvider";
import ChevronSvg from "../Svgs/ChevronSvg";
import { useForm } from "@mantine/form";
import { DateInput } from "@mantine/dates";
import moment from "moment";

import AddProvider from "./AddProvider";

const useStyles = createStyles(() => ({
  eligibilitybox: {
    background: "#FFF",
    padding: "16px 43px",
    width: "98%",
    borderRadius: "8px",
    marginBottom: "193px",

    // marginBottom: "20px",
  },

  dateInputWithIcon: {
    "[data-with-icon]": {
      // padding: "10px 14px",
      borderRadius: "8px",
      height: "44px",
      border: "1px solid #D0D5DD",
      background: "#FFF",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    },
  },

  flexbutton: {
    display: "flex",
    justifyContent: "flex-end",
  },

  datepicker: {
    padding: "10px 14px",
    borderRadius: "8px",
    border: "1px solid #D0D5DD",
    background: "#FFF",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
  },

  box: {
    background: "#F5F5F5",
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    marginBottom: "31px",
    // width:'50%',
  },

  textbox: {
    fontSize: "16px",
    padding: "10px 0px 10px 20px",
    fontWeight: "600",
    color: "#262626",
  },

  line: {
    borderBottom: "1px solid var(--neutral-200, #E5E5E5)",
    marginTop: "26px",
    marginBottom: "26px",
  },

  margin: {
    //  marginTop:'29px',
    backgroundColor: "#FFF",
    padding: "21px 24px 24px 29px",
    // padding: "29px 24px 21px 24px",
    // marginBottom:'21px'
  },

  providerbox: {
    backgroundColor: "#FFF",
    padding: "21px 24px 35px 29px",
    borderRadius: "12px",
  },

  provider: {
    color: "#3F3F46",
    fontSize: "16px",
    fontWeight: 600,
    padding: "11px 14px",
    borderRadius: "8px",
    backgroundColor: bgColor,
    border: "1px solid #E5E5E5",
    cursor: "pointer",
  },

  main: {
    display: "flex",
    gap: "11px",
    justifyContent: "center",
  },

  addprovider: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "14px",
    marginTop: "13px",
    color: "#FFAF4A",
    fontSize: "14px",
    fontWeight: "600",
  },

  patientbox: {
    padding: "10px 24px 29px 20px",
    alignItems: "center",
    background: "#FFF",
    borderRadius: "13px",
  },

  flex: {
    display: "flex",
    justifyContent: "space-between",
    gap: "11px",
    marginTop: "18px",
    marginBottom: "24px",
    width: "100%",
  },

  borderbox: {
    padding: "12px 12px 20px 12px",
    borderRadius: "12px",
    border: "1px solid #E5E5EA",
    background: "#FFF",
  },

  spantext: {
    color: "#171717",
    fontSize: 18,
    fontWeight: 400,
  },

  flexborder: {
    display: "flex",
    justifyContent: "space-between",
  },

  roundbox: {
    padding: "4px 12px",
    color: "#344054",
    background: "#F2F4F7",
    textAlign: "center",
    fontSize: 14,
    fontWeight: 500,
    width: "112px",
    height: "28px",
    borderRadius: "16px",
  },

  width: {
    width: "50%",
  },
}));
// const bgColor = "#D9D9D9";

const bgColor = "#FFFFFF";

const CustomTextInput = ({ icon, ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "8px 12px",
      height: "48px",
      borderRadius: "8px",
      backgroundColor: bgColor,
      border: "1px solid #E5E5E5",
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput icon={icon} required {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "8px 12px",
      borderRadius: "8px",
      backgroundColor: bgColor,
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        required
        rightSection={<IconChevronDown color={"#A3A3A3"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function CheckEligibilty({ state, setState, selectedData }) {
  // console.log('selectedData',selectedData);

  const { classes } = useStyles();

  const { profile } = useSelector((state) => state?.profile);
  const { allpayer } = useSelector((state) => state.payer);

  const { eligibilitydata } = useSelector((state) => state.billing);

  const [loading, setLoading] = useState(false);
  const [providerstate, setProviderState] = useState(false);
  const [addprovider, setAddProvider] = useState({
    addProvider: false,
  });

  const [activeTab, setActiveTab] = useState({
    plan: true,
    benefit: false,
    additional: false,
  });

  // console.log('patients',patients);

  console.log("eligibilitydata", eligibilitydata);

  const [eligibilitystatus, setEligibilitystatus] = useState({
    provider: null,
    payer: null,
  });

  const form = useForm({
    initialValues: {
      clientFirstname: "",
      clientlastname: "",
      clientdob: "",
      clientgender: "",
      clientInsuranceId: "",
      serviceCode: "",
      fdos: "",
      relationshipToInsured: "",
    },
  });

  const allbillingprovider = useSelector(
    (state) => state.billingprovider?.allbillingprovider
  );

  // console.log("allbillingprovider", allbillingprovider);

  console.log("eligibilitystatus", eligibilitystatus);

  const allowedServiceCodes = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "30",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "A0",
    "A1",
    "A3",
    "A4",
    "A5",
    "A6",
    "A7",
    "A8",
    "A9",
    "AA",
    "AB",
    "AC",
    "AD",
    "AE",
    "AF",
    "AG",
    "AH",
    "AI",
    "AJ",
    "AK",
    "AL",
    "AM",
    "AN",
    "AO",
    "AP",
    "AQ",
    "AR",
    "B1",
    "B2",
    "B3",
    "BA",
    "BB",
    "BC",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BK",
    "BL",
    "BM",
    "BN",
    "BP",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BU",
    "BV",
    "BW",
    "BX",
    "BY",
    "BZ",
    "C1",
    "CA",
    "CB",
    "CC",
    "CD",
    "CE",
    "CF",
    "CG",
    "CH",
    "CI",
    "CJ",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CP",
    "CQ",
    "DG",
    "DM",
    "DS",
    "GF",
    "GN",
    "GY",
    "IC",
    "MH",
    "NI",
    "ON",
    "PT",
    "PU",
    "RN",
    "RT",
    "TC",
    "TN",
    "UC",
    "E0",
    "E1",
    "E2",
    "E3",
    "E4",
    "E5",
    "E6",
    "E7",
    "E8",
    "E9",
    "E10",
    "E11",
    "E12",
    "E13",
    "E14",
    "E15",
    "E16",
    "E17",
    "E18",
    "E19",
    "E20",
    "E21",
    "E22",
    "E23",
    "E24",
    "E25",
    "E26",
    "E27",
    "E28",
    "E29",
    "E30",
    "E31",
    "E32",
    "E33",
    "E34",
    "E35",
    "E36",
    "EA",
    "EB",
    "EC",
    "ED",
    "EE",
    "EF",
    "SMH",
  ];

  useEffect(() => {
    setEligibilitystatus({
      ...eligibilitystatus,
      provider: allbillingprovider?.billingprovider?.find(
        (item) => item?.id === selectedData?.provider
      ),
      payer: selectedData?.payer,
      client: selectedData?.client,
    });
  }, [selectedData]);

  const handleTabClick = (tab) => {
    setActiveTab({
      plan: false,
      benefit: false,
      additional: false,
      [tab]: true,
    });
  };

  const onSave = async () => {
    try {
      let values = form.values;

      let missingFields = [];

      console.log("values", values);
      console.log("missingFields", missingFields);

      // console.log("eligibilitystatus", eligibilitystatus);

      let payload = {
        ins_name_f: values?.clientFirstname,
        ins_name_l: values?.clientlastname,
        payerid: eligibilitystatus?.payer,
        pat_rel: values?.relationshipToInsured,
        // fdos: "2022-10-13",
        fdos: moment(values?.fdos).format("YYYYMMDD"),
        prov_npi: eligibilitystatus?.provider?.prov_npi || "1111111112",
        // prov_npi: eligibilitystatus.provider?.billingIdentifier.number,
        prov_taxid:
          eligibilitystatus?.provider?.federalTaxID?.number || "208655599",
        service_code: values?.serviceCode || "30",
        // service_code:eligibilitystatus?.provider?.serviceCode.code,
        ins_number: values?.clientInsuranceId,
        ins_dob: moment(values?.clientdob).format("YYYYMMDD"),
        ins_sex: values?.clientgender,
        //   prov_npi: "1111111112", //  provider?.billingIdentifier?.number, "1111111112",
        //   prov_taxid: "208655599", //provider?.taxonomy, //"208655599",

        providerid: eligibilitystatus?.provider?.id,
        admin: profile?.user?.id,
        proc_code: values?.proc_code,
      };

      // Object.entries(payload).forEach(
      //   ([key, value]) => !value && missingFields.push(key)
      // );

      Object.entries(payload).forEach(([key, value]) => {
        if (
          key !== "service_code" &&
          key !== "proc_code" &&
          (value === undefined ||
            value === null ||
            value === "" ||
            value === "Invalid date")
        ) {
          missingFields.push(key);
        }
      });

      if (missingFields.length > 0) {
        await swal({
          title: "Please fill out the following fields",
          text: missingFields.join(", "),
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      const hasServiceCode = !!values?.serviceCode;
      const hasProcCode = !!values?.proc_code;

      // if (!hasServiceCode && !hasProcCode) {
      //   await swal({
      //     title: "Missing Fields",
      //     text: "please enter at least one service code or proc code",
      //     icon: "warning",
      //     dangerMode: true,
      //   });
      //   //missingFields.push("Either 'service_code' or 'proc_code'");
      //   return;
      // }

      if (hasServiceCode && !allowedServiceCodes.includes(values.serviceCode)) {
        // missingFields.push("Wrong Service Code");
        await swal({
          title: "Incorrect Service Code",
          text: "please enter correct Service Code",
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      if (
        hasProcCode &&
        !eligibilitystatus?.provider?.services?.some(
          (code) => code?.servicenumber === values.proc_code
        )
      ) {
        // missingFields.push("Wrong Procedure Code");
        await swal({
          title: "Incorrect Procedure Code",
          text: "please enter correct Procedure Code",
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      console.log("payload", payload);

      const willDelete = await swal({
        title: `Do you wish to continue?`,
        text: "Running an eligibility verification will incur a non-refundable $0.50 fee per request. This charge will be automatically included in your next month’s Ogiso Billing cycle.",
        icon: "warning",
        dangerMode: true,
        buttons: ["Cancel", "Yes, Proceed"],
      });

      if (willDelete) {
        setLoading(true);
        let res = await getelibilitystatus(payload);

        console.log("res", res);

        if (res?.data?.eligibility?.error) {
          showError(res?.data.eligibility?.error?.error_mesg);
        }
        if (res?.data?.notallowed) {
          await swal({
            title: res?.data?.message,
            text: res?.data?.notallowed,
            icon: "warning",
            dangerMode: true,
          });
        }

        if (res?.data?.eligibility?.elig && res?.data?.message === "Eligible") {
          await swal({
            title: res?.data?.message,
            text: res?.data?.message,
            icon: "success",
            dangerMode: false,
          });
        }
      }

      // setEligibilitystatus({
      //   provider: null,
      //   payer: null,
      // });
      // form.reset();

      // setEligibilitystatus({
      //   provider: null,
      //   payer: null,

      // });
    } catch (error) {
      console.log("error", error);
    } finally {
      setEligibilitystatus({
  provider: null,
  payer: null,
});
      setLoading(false);
      form.reset();
    }
  };

  // console.log("==========", eligibilitystatus);

  return (
    <>
      <Box className={classes.eligibilitybox}>
        {eligibilitydata ? (
          <Box>
            <Flex
              gap={8}
              className={classes.provider}
              align={"center"}
              style={{ flex: 1 }}
            >
              <Button
                // onClick={onSave}
                variant="fixed"
                loading={loading}
                onClick={() => handleTabClick("plan")}
                className={classes.backNextBtn}
                // c={"#262626"}
                // color="yellow"
                // c="#262626"

                c={activeTab.plan ? "#171717" : "#262626"}
                bg={activeTab.plan ? "#FFAF4A" : "#F9FAFB"}
                // type='submit'
                radius="md"
                size="md"
              >
                Plan Details
              </Button>

              <Button
                // onClick={onSave}
                variant="fixed"
                loading={loading}
                onClick={() => handleTabClick("benefit")}
                className={classes.backNextBtn}
                // c={"#262626"}
                // bg={"#F9FAFB"}
                // color="yellow"
                c={activeTab.benefit ? "#171717" : "#262626"}
                bg={activeTab.benefit ? "#FFAF4A" : "#F9FAFB"}
                // type='submit'
                radius="md"
                size="md"
              >
                Benefit Details
              </Button>

              {/* <Button
                // onClick={onSave}
                variant="fixed"
                onClick={() => handleTabClick("additional")}
                loading={loading}
                className={classes.backNextBtn}
                // c={"#262626"}
                c={activeTab.additional ? "#171717" : "#262626"}
                bg={activeTab.additional ? "#FFAF4A" : "#F9FAFB"}
                // color="yellow"
                // type='submit'
                radius="md"
                // bg={"#F9FAFB"}
                size="md"
              >
                Additional Details
              </Button> */}
            </Flex>

            <Box className={classes.line}></Box>

            {activeTab?.plan ? (
              <>
                <Text
                  style={{ marginBottom: "12px" }}
                  ff={"Inter"}
                  fz={16}
                  fw={600}
                  color="#171717"
                >
                  Search Criteria
                </Text>

                <Box className={classes.borderbox}>
                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Subscriber First Name
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.ins_name_f || "-"}{" "}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Subscriber Last Name
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.ins_name_l || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Subscriber Date Of Birth
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.ins_dob || "-"} */}
                        {eligibilitydata?.data?.ins_dob
                          ? moment(
                              eligibilitydata?.data?.ins_dob,
                              "YYYYMMDD"
                            ).format("MM/DD/YYYY")
                          : "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Subscriber Gender
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data.ins_sex || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Member ID
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.ins_number || "-"}
                      </Text>
                    </Box>
                  </Box>

                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Date Of Service
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.elig_result_date || "-"} */}
                        {eligibilitydata?.data?.elig_result_date
                          ? moment(
                              eligibilitydata?.data?.elig_result_date,
                              "YYYYMMDD"
                            ).format("MM/DD/YYYY")
                          : "-"}
                      </Text>
                    </Box>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Patient Relationship
                      </Text>
                      {/* <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
              
                        {eligibilitydata?.patientRelationship || "-"}
                       
                      </Text> */}
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {[
                          { value: "18", label: "self" },
                          { value: "1", label: "spouse" },
                          { value: "19", label: "child" },
                          { value: "G8", label: "other" },
                        ].find(
                          (opt) =>
                            opt.value === eligibilitydata?.patientRelationship
                        )?.label || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        NPI
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.elig_result_date || "-"} */}
                        {eligibilitydata?.provider?.federalTaxID?.number || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Date Of Service
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.elig_result_date || "-"} */}
                        {eligibilitydata?.data?.elig_result_date
                          ? moment(
                              eligibilitydata?.data?.elig_result_date,
                              "YYYYMMDD"
                            ).format("MM/DD/YYYY")
                          : "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Payer ID
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.payer?.payerId || "-"}
                        {/* {eligibilitydata?.elig_result_date
                          ? moment(
                              eligibilitydata.elig_result_date,
                              "YYYYMMDD"
                            ).format("MM/DD/YYYY")
                          : "-"} */}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Tax ID
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.provider?.federalTaxID?.number || "-"}
                      </Text>
                    </Box>

                    {/* <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Service Type
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        -
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Time
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.elig_result_time
                          ? moment(
                              eligibilitydata.elig_result_time,
                              "HHmm"
                            ).format("hh:mm A")
                          : "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Support Plan
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.plan_number || "-"}
                      </Text>
                    </Box> */}
                  </Box>
                </Box>

                <Box style={{ marginTop: "22px", marginBottom: "10px" }}>
                  <Text ff={"Inter"} fz={16} fw={600} color="#171717">
                    Payer Response
                  </Text>
                  <Text ff={"Inter"} fz={14} fw={400} color="#737373">
                    Subscriber Information
                  </Text>
                </Box>

                <Box className={classes.borderbox}>
                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Member First Name
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data.ins_name_f || "-"}{" "}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Member Last Name
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data.ins_name_l || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Member ID
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.ins_number || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Date of Birth
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.ins_dob || "-"} */}
                        {eligibilitydata?.data?.ins_dob
                          ? moment(
                              eligibilitydata.data.ins_dob,
                              "YYYYMMDD"
                            ).format("MM/DD/YYYY")
                          : "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Gender
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data.ins_sex || "-"}
                      </Text>
                    </Box>
                  </Box>

                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Group name
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.group_number || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Group number
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.group_number || "-"}
                      </Text>
                    </Box>

                    {/* <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Plan number
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.plan_number || "-"}
                      </Text>
                    </Box> */}

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Plan Begin Date
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.plan_begin_date || "-"} */}
                        {eligibilitydata?.data?.plan_begin_date
                          ? (() => {
                              const [start, end] =
                                eligibilitydata.data.plan_begin_date.split("-");
                              const formattedStart = moment(
                                start,
                                "YYYYMMDD"
                              ).format("MM/DD/YYYY");

                              return `${formattedStart}`;
                            })()
                          : "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Time
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.elig_result_time || "-"} */}
                        {eligibilitydata?.data?.elig_result_time
                          ? moment(
                              eligibilitydata.data?.elig_result_time,
                              "HHmm"
                            ).format("hh:mm A")
                          : "-"}
                      </Text>
                    </Box>

                    {/* <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Support Plan
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.plan_number || "-"}
                      </Text>
                    </Box> */}
                  </Box>

                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Address
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.ins_addr_1 || "-"}
                      </Text>
                    </Box>
                  </Box>
                </Box>

                <Flex
                  mt={69}
                  mb={19}
                  align={"center"}
                  justify="space-between"
                  style={{ flex: 1 }}
                >
                  <Text ff={"Inter"} fz={18} fw={400} color="#A1A1AA">
                    Plan name:
                    <span className={classes.spantext}>
                      {" "}
                      {eligibilitydata?.data?.plan_number || "-"}{" "}
                    </span>
                  </Text>

                  {/* <Text ff={"Inter"} fz={18} fw={400} color="#A1A1AA">
                    Insurance Type Code:
                    <span className={classes.spantext}>
                      {eligibilitydata?.benefit[0]?.insurance_type_code || "-"}
                    </span>
                  </Text> */}

                  <Text ff={"Inter"} fz={18} fw={400} color="#A1A1AA">
                    Date of last Update
                    <span className={classes.spantext}>
                      {/* {eligibilitydata?.elig_result_date || "-"} */}
                      {eligibilitydata?.data?.elig_result_date
                        ? moment(
                            eligibilitydata.data?.elig_result_date,
                            "YYYYMMDD"
                          ).format("MM/DD/YYYY")
                        : "-"}
                    </span>
                  </Text>
                </Flex>

                <Text
                  style={{ marginBottom: "24px" }}
                  ff={"Inter"}
                  fz={18}
                  fw={400}
                  color="#A1A1AA"
                >
                  Medicare ID:
                  <span className={classes.spantext}>
                    {" "}
                    {eligibilitydata?.payer?.payerId || "-"}
                  </span>
                </Text>

                <Text ff={"Inter"} fz={16} fw={600} color="#171717">
                  Active Coverage
                </Text>

                <Text
                  style={{ marginBottom: "16px" }}
                  ff={"Inter"}
                  fz={14}
                  fw={400}
                  color="#737373"
                >
                  Patient/Client Plan Details
                </Text>

                <Box className={classes.borderbox}>
                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Payer Name
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.payer?.payerName}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Payer Id
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.elig_result_date || "-"} */}
                        {eligibilitydata?.payer?.payerId || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Plan name
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.plan_number || "-"}{" "}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Plan number
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.plan_number || "-"}{" "}
                      </Text>
                    </Box>
                  </Box>

                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Gender
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.data?.ins_sex || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Patient/Client Number
                      </Text>
                      {eligibilitydata?.data?.group_number || "-"}
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Eligibility Date Range
                      </Text>
                      {/* <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitystatus?.benefit[71]?.entity_website || "-"}
                      </Text> */}
                      {eligibilitydata?.data?.plan_begin_date
                        ? (() => {
                            const [start, end] =
                              eligibilitydata.data.plan_begin_date.split("-");
                            const formattedStart = moment(
                              start,
                              "YYYYMMDD"
                            ).format("MM/DD/YYYY");

                            const formattedEnd = moment(end, "YYYYMMDD").format(
                              "MM/DD/YYYY"
                            );
                            return `${formattedStart} - ${formattedEnd}`;

                            return `${formattedStart}`;
                          })()
                        : "-"}
                    </Box>
                  </Box>

                  <Box className={classes.line}></Box>
                  <Box>
                    <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                      Address
                    </Text>
                    <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                      {eligibilitydata?.data?.ins_addr_1 || "-"}
                    </Text>
                  </Box>
                </Box>
              </>
            ) : (
              <>
                <Box className={classes.borderbox}>
                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit Amount
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[1]?.benefit_amount || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit code
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[0]?.benefit_code || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit level code
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.ins_dob || "-"} */}
                        {eligibilitydata?.benefit[1]?.benefit_level_code || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit period code
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[1]?.benefit_period_code ||
                          "-"}
                      </Text>
                    </Box>
                  </Box>

                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Insurance plan
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[0]?.insurance_plan || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Inplan network
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[1]?.inplan_network || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Insurance type code
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {/* {eligibilitydata?.ins_dob || "-"} */}
                        {eligibilitydata?.benefit[0]?.insurance_type_code ||
                          "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Insurance type description
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[0]
                          ?.insurance_type_description || "-"}
                      </Text>
                    </Box>
                  </Box>

                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit coverage description
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[1]
                          ?.benefit_coverage_description || "-"}
                      </Text>
                    </Box>

                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit level description
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[1]
                          ?.benefit_level_description || "-"}
                      </Text>
                    </Box>
                  </Box>

                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit description
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[0]?.benefit_description ||
                          "-"}
                      </Text>
                    </Box>
                  </Box>
                  <Box className={classes.line}></Box>

                  <Box className={classes.flexborder}>
                    <Box>
                      <Text ff={"Inter"} fz={12} fw={400} color="#737373">
                        Benefit notes
                      </Text>
                      <Text color="#262626" ff={"Inter"} fz={14} fw={600}>
                        {eligibilitydata?.benefit[0]?.benefit_notes || "-"}
                      </Text>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </Box>
        ) : (
          <>
            <Box className={classes.main}>
              <Box style={{ width: "30%" }} className={classes.box}>
                <Box className={classes.textbox}>Payer</Box>

                <Box className={classes.margin}>
                  <CustomSelectBox
                    id="billing-type"
                    placeholder={"Select Payer"}
                    withAsterisk
                    limit={10}
                    searchable
                    data={(allpayer && allpayer?.payer
                      ? allpayer?.payer
                      : []
                    ).map((item) => ({
                      value: item.id,
                      label: item?.payerName,
                    }))}
                    onChange={(value) =>
                      setEligibilitystatus((prevState) => ({
                        ...prevState,
                        payer: value,
                      }))
                    }
                    // {...form.getInputProps("payerEntity")}
                  />
                </Box>
              </Box>

              <Box style={{ width: "70%" }} className={classes.box}>
                <Box className={classes.textbox}>Provider</Box>

                <Box
                  onClick={() => {
                    setProviderState(true);
                  }}
                  className={classes.providerbox}
                >
                  <Flex
                    className={classes.provider}
                    align={"center"}
                    justify="space-between"
                    style={{ flex: 1 }}
                  >
                    <Text>
                      {eligibilitystatus?.provider?.name || "Select Provider"}
                    </Text>
                    <ChevronSvg />
                  </Flex>
                  {/* 
          <Text className={classes.provider}>Business Assisted Living</Text> */}
                </Box>
              </Box>
            </Box>

            <Box
              style={{ cursor: "pointer" }}
              onClick={() =>
                setAddProvider((prev) => ({ ...prev, addProvider: true }))
              }
              className={classes.addprovider}
            >
              + Add Provider
            </Box>

            <form onSubmit={form.onSubmit((values) => onSave(values))}>
              <Box className={classes.box}>
                <Box className={classes.textbox}>Patients search criteria</Box>

                <Box className={classes.patientbox}>
                  <Box className={classes.flex}>
                    <Box className={classes.width}>
                      <Text
                        color="#344054"
                        fz={14}
                        fw={500}
                        style={{ marginBottom: "8px" }}
                      >
                        Client First name
                      </Text>
                      <CustomTextInput
                        placeholder="Sandra"
                        required
                        withAsterisk
                        {...form.getInputProps("clientFirstname")}
                      />
                    </Box>

                    <Box className={classes.width}>
                      <Text
                        color="#344054"
                        fz={14}
                        fw={500}
                        style={{ marginBottom: "8px" }}
                      >
                        Client Last name
                      </Text>
                      <CustomTextInput
                        placeholder="olivia"
                        required
                        withAsterisk
                        {...form.getInputProps("clientlastname")}
                      />
                    </Box>
                  </Box>

                  <Box className={classes.flex}>
                    <Box className={classes.width}>
                      <Text
                        color="#344054"
                        fz={14}
                        fw={500}
                        style={{ marginBottom: "8px" }}
                      >
                        Client DOB
                      </Text>

                      <DateInput
                        className={classes.dateInputWithIcon}
                        icon={
                          <img
                            style={{ width: "20px" }}
                            src={"/assets/images/billingcalendar.png"}
                            alt="Icon"
                          />
                        }
                        valueFormat=" MM DD YYYY"
                        placeholder="MM/DD/YYYY"
                        required
                        withAsterisk
                        {...form.getInputProps("clientdob")}
                      />
                    </Box>

                    <Box className={classes.width}>
                      <Text
                        color="#344054"
                        fz={14}
                        fw={500}
                        style={{ marginBottom: "8px" }}
                      >
                        Client Gender
                      </Text>
                      <CustomSelectBox
                        id="billing-type"
                        placeholder={"Select Gender"}
                        withAsterisk
                        data={[
                          { value: "male", label: "Male" },
                          { value: "female", label: "Female" },
                          { value: "other", label: "Others" },
                        ]}
                        {...form.getInputProps("clientgender")}
                      />
                    </Box>
                  </Box>

                  <Box className={classes.flex}>
                    <Box className={classes.width}>
                      <Text
                        color="#344054"
                        fz={14}
                        fw={500}
                        style={{ marginBottom: "8px" }}
                      >
                        Member ID
                      </Text>
                      <CustomTextInput
                        placeholder="olivia@ogiso.com"
                        required
                        withAsterisk
                        {...form.getInputProps("clientInsuranceId")}
                      />
                    </Box>

                    <Box className={classes.width}>
                      <Text
                        color="#344054"
                        fz={14}
                        fw={500}
                        style={{ marginBottom: "8px" }}
                      >
                        Client Relationship
                      </Text>
                      <CustomSelectBox
                        id="billing-type"
                        placeholder={"Select Client Relationship"}
                        withAsterisk
                        data={[
                          { value: "18", label: "self" },
                          { value: "1", label: "spouse" },
                          { value: "19", label: "child" },
                          { value: "G8", label: "other" },
                        ]}
                        {...form.getInputProps("relationshipToInsured")}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box className={classes.flex}>
                <Box style={{ width: "50%" }} className={classes.box}>
                  <Box className={classes.textbox}>Service code</Box>

                  <Box className={classes.patientbox}>
                    {/* <CustomSelectBox
                      id="billing-type"
                      placeholder={"Select Service Code"}
                      withAsterisk
                      data={[
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8",
                        "9",
                        "10",
                        "11",
                        "12",
                        "13",
                        "14",
                        "15",
                        "16",
                        "17",
                        "18",
                        "19",
                        "20",
                        "21",
                        "22",
                        "23",
                        "24",
                        "25",
                        "26",
                        "27",
                        "28",
                        "30",
                        "32",
                        "33",
                        "34",
                        "35",
                        "36",
                        "37",
                        "38",
                        "39",
                        "40",
                        "41",
                        "42",
                        "43",
                        "44",
                        "45",
                        "46",
                        "47",
                        "48",
                        "49",
                        "50",
                        "51",
                        "52",
                        "53",
                        "54",
                        "55",
                        "56",
                        "57",
                        "58",
                        "59",
                        "60",
                        "61",
                        "62",
                        "63",
                        "64",
                        "65",
                        "66",
                        "67",
                        "68",
                        "69",
                        "70",
                        "71",
                        "72",
                        "73",
                        "74",
                        "75",
                        "76",
                        "77",
                        "78",
                        "79",
                        "80",
                        "81",
                        "82",
                        "83",
                        "84",
                        "85",
                        "86",
                        "87",
                        "88",
                        "89",
                        "90",
                        "91",
                        "92",
                        "93",
                        "94",
                        "95",
                        "96",
                        "97",
                        "98",
                        "99",
                        "A0",
                        "A1",
                        "A3",
                        "A4",
                        "A5",
                        "A6",
                        "A7",
                        "A8",
                        "A9",
                        "AA",
                        "AB",
                        "AC",
                        "AD",
                        "AE",
                        "AF",
                        "AG",
                        "AH",
                        "AI",
                        "AJ",
                        "AK",
                        "AL",
                        "AM",
                        "AN",
                        "AO",
                        "AP",
                        "AQ",
                        "AR",
                        "B1",
                        "B2",
                        "B3",
                        "BA",
                        "BB",
                        "BC",
                        "BD",
                        "BE",
                        "BF",
                        "BG",
                        "BH",
                        "BI",
                        "BJ",
                        "BK",
                        "BL",
                        "BM",
                        "BN",
                        "BP",
                        "BQ",
                        "BR",
                        "BS",
                        "BT",
                        "BU",
                        "BV",
                        "BW",
                        "BX",
                        "BY",
                        "BZ",
                        "C1",
                        "CA",
                        "CB",
                        "CC",
                        "CD",
                        "CE",
                        "CF",
                        "CG",
                        "CH",
                        "CI",
                        "CJ",
                        "CK",
                        "CL",
                        "CM",
                        "CN",
                        "CO",
                        "CP",
                        "CQ",
                        "DG",
                        "DM",
                        "DS",
                        "GF",
                        "GN",
                        "GY",
                        "IC",
                        "MH",
                        "NI",
                        "ON",
                        "PT",
                        "PU",
                        "RN",
                        "RT",
                        "TC",
                        "TN",
                        "UC",
                        "E0",
                        "E1",
                        "E2",
                        "E3",
                        "E4",
                        "E5",
                        "E6",
                        "E7",
                        "E8",
                        "E9",
                        "E10",
                        "E11",
                        "E12",
                        "E13",
                        "E14",
                        "E15",
                        "E16",
                        "E17",
                        "E18",
                        "E19",
                        "E20",
                        "E21",
                        "E22",
                        "E23",
                        "E24",
                        "E25",
                        "E26",
                        "E27",
                        "E28",
                        "E29",
                        "E30",
                        "E31",
                        "E32",
                        "E33",
                        "E34",
                        "E35",
                        "E36",
                        "EA",
                        "EB",
                        "EC",
                        "ED",
                        "EE",
                        "EF",
                        "SMH",
                      ].map((code) => ({
                        value: code,
                        label: code,
                      }))}
                      {...form.getInputProps("serviceCode")}
                    /> */}

                    <CustomTextInput
                      placeholder="Service Code"
                      // required
                      // withAsterisk
                      maxLength={3}
                      {...form.getInputProps("serviceCode")}
                    />
                  </Box>
                </Box>

                <Box style={{ width: "50%" }} className={classes.box}>
                  <Box className={classes.textbox}>Procedure code</Box>

                  <Box className={classes.patientbox}>
                    {/* <CustomSelectBox
                      id="billing-type"
                      placeholder={"Select Procedure Service"}
                      withAsterisk
                      data={
                        eligibilitystatus?.provider?.services?.map((code) => ({
                          value: code?.servicenumber,
                          label: code?.servicenumber,
                        })) || []
                      }
                      {...form.getInputProps("proc_code")}
                    /> */}

                    <CustomTextInput
                      placeholder="Procedure Code"
                      // required
                      // withAsterisk
                      // maxLength={3}
                      {...form.getInputProps("proc_code")}
                    />
                  </Box>
                </Box>
              </Box>

              <Box className={classes.box}>
                <Box className={classes.textbox}>Date of service</Box>

                <Box className={classes.patientbox}>
                  {/* <CustomTextInput
              icon={
                <img
                  style={{ width: "20px" }}
                  src={"/assets/images/billingcalendar.png"}
                  alt="Icon"
                />
              }
              placeholder="DD/MM/YYYY"
              required
              withAsterisk
              {...form.getInputProps("fdos")}

            /> */}
                  <DateInput
                    className={classes.dateInputWithIcon}
                    icon={
                      <img
                        style={{ width: "20px" }}
                        src={"/assets/images/billingcalendar.png"}
                        alt="Icon"
                      />
                    }
                    valueFormat="MM DD YYYY"
                    placeholder="MM/DD/YYYY"
                    required
                    withAsterisk
                    {...form.getInputProps("fdos")}
                  />
                </Box>
              </Box>

              <Box className={classes.flexbutton}>
                <Button
                  onClick={onSave}
                  variant="filled"
                  loading={loading}
                  c={"#000"}
                  color="yellow"
                  // type='submit'
                  radius="md"
                  size="md"
                >
                  Submit
                </Button>
              </Box>
            </form>
          </>
        )}
      </Box>

      <EligibilityProvider
        state={providerstate}
        setState={setProviderState}
        eligibilitystatus={eligibilitystatus}
        setEligibilitystatus={setEligibilitystatus}
      />

      <AddProvider state={addprovider} setState={setAddProvider} />
    </>
  );
}

export default CheckEligibilty;
